export default __webpack_public_path__ + "static/media/mk.a76072d1.svg";